import { render } from "./WorkflowsPage.vue?vue&type=template&id=799261f4&ts=true"
import script from "./WorkflowsPage.vue?vue&type=script&lang=ts"
export * from "./WorkflowsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__